import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/home.vue')
    },
    {
      path: '/list',
      name: 'list',
      component: () => import('./views/ProductList.vue')
    },
    {
      path: '/productdetail/:productId',
      name: 'ProductDetail',
      component: () => import('./views/ProductDetail.vue')
    },
    {
      path: '/manageproduct/:productId',
      name: 'ManageProduct',
      component: () => import('./views/ManageProduct.vue')
    },
    {
      path: '/manageproduct',
      name: 'ManageProduct',
      component: () => import('./views/ManageProduct.vue')
    },
    {
      path: '/user/address',
      name: 'address',
      component: () => import('./views/user/Address.vue')
    },
    {
      path: '/user/orderhistory',
      name: 'orderhistory',
      component: () => import('./views/user/OrderHistory.vue')
    },
    {
      path: '/user/trackingorder',
      name: 'trackingorder',
      component: () => import('./views/user/TrackingOrder.vue')
    },
    // {
    //   path: '/register-cid',
    //   name: 'RegisterCid',
    //   component: () => import('./views/RegisterCid.vue')
    // },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('./views/Contact.vue')
    },
    {
      path: '/notSessionToken',
      name: 'notSessionToken',
      component: () => import('./views/NotSessionToken.vue')
    },
    {
      path: '*',
      name: 'home',
      component: () => import('./views/home.vue')
    }
  ]
})
